import { HiOutlineDocumentText } from "react-icons/hi"
import { Button, ButtonLoader } from "../../components/Button"
import { FormRow, Label, SelectInput, TextArea, Input } from "../../components/Form"
import {
  ModalBody,
  ModalDouble,
  ModalFooter,
  ModalHeader,
  ModalPanel,
} from "../../components/Modal"
import ModalAlert from "../../components/ModalAlert"
import "./styles.scss"
import { ListViewTemplates } from "../../components/ListView"

const ModalConfirmationOptions = ({
  loading,
  sessionWhatsApp,
  formsByProject,
  handleChangeInput,
  steps,
  groups,
  groupQuestions,
  values,
  handleSendTemplate,
  handleMessage,
  message,
  templateTermsList,
  showTemplateList,
  selectedTemplate,
  handleOpenTemplateList,
  handleCloseTemplateList,
  setSelectedTemplate,
  handleCreateTemplate,
  pinnedMessages,
}) => {
  return (
    <>
      <ModalDouble position="left">
        <div className="modal-double-terms">
          <div className="form-group-box-date">
            <h3 className="section-title">Dados da Comunicação</h3>
            <FormRow>
              <Label
                label="Empresa"
              />
              <SelectInput
                name="company"
                isSearchable
                placeholder="Selecione a Empresa"
                options={[
                  { label: "Empresa A", value: "empresa-a" },
                  { label: "Empresa B", value: "empresa-b" },
                  { label: "Empresa C", value: "empresa-c" }
                ]}
                handleChange={handleChangeInput("company")}
                isRequired={true}
                isOverModal={true}
                isClearable={true}
              />
            </FormRow>
            <FormRow>
              <Label
                label="Assunto"
              />
              <Input
                name="subject"
                placeholder="Digite o assunto da comunicação"
                onChange={(e) => handleChangeInput("subject")(e.target.value)}
                value={values?.subject || ""}
                required={true}
              />
            </FormRow>
            <FormRow>
              <Label
                label="Descrição"
              />
              <TextArea
                name="description"
                placeholder="Digite a descrição detalhada da comunicação"
                onChange={(e) => handleChangeInput("description")(e.target.value)}
                value={values?.description || ""}
                resize="vertical"
                height="200px"
              />
            </FormRow>
          </div>
        </div>
      </ModalDouble>
      <ModalDouble position="right" className="secondary">
        <div className="modal-double-messages">
          <h3 className="section-title">Mensagens Selecionadas ({pinnedMessages?.length || 0})</h3>
          {pinnedMessages && pinnedMessages.length > 0 ? (
            <div className="selected-messages-container">
              {pinnedMessages.map((msg, index) => (
                <div key={index} className="selected-message-card">
                  <div className="message-header">
                    <strong>{msg.author || msg.userName || 'Usuário'}</strong>
                    <span className="message-time">{msg.time || msg.createdAt || ''}</span>
                  </div>
                  {msg.media ? (
                    <div className="message-media">
                      {msg.media.type === 'image' ? (
                        <img src={msg.media.url} alt="Imagem" className="message-image" />
                      ) : msg.media.type === 'video' ? (
                        <video src={msg.media.url} controls className="message-video" />
                      ) : msg.media.type === 'audio' ? (
                        <audio src={msg.media.url} controls className="message-audio" />
                      ) : (
                        <a href={msg.media.url} target="_blank" rel="noopener noreferrer" className="message-file">
                          📎 {msg.media.name || 'Arquivo anexado'}
                        </a>
                      )}
                    </div>
                  ) : (
                    <p className="message-text">{msg.message || msg.content || ''}</p>
                  )}
                </div>
              ))}
            </div>
          ) : (
            <div className="no-messages">
              <p>Nenhuma mensagem selecionada</p>
              <span>Selecione mensagens no chat usando o botão +</span>
            </div>
          )}
        </div>
      </ModalDouble>
    </>
  )
}

export const SendTermsOfUseScreen = ({
  modalTermsIsOpen,
  setModalTermsIsOpen,
  templateTermsList,
  selectedUsers,
  selectedTerm,
  handleSelectedTerm,
  checkedUsers,
  onCheckedChange,
  handleSendTemplate,
  loading,
  formsByProject,
  handleChangeInput,
  steps,
  groups,
  groupQuestions,
  values,
  handleMessage,
  message,
  showTemplateList,
  handleOpenTemplateList,
  handleCloseTemplateList,
  handleSetSelectedTemplate,
  selectedTemplate,
  handleCreateTemplate,
  pinnedMessages,
}) => {
  return (
    <>
      {modalTermsIsOpen && (
        <ModalPanel modalIsOpen={modalTermsIsOpen}>
          <ModalHeader closeModal={() => setModalTermsIsOpen(false)} title="Enviar Comunicação" />
          <ModalBody className="send-terms-user">
            <ModalConfirmationOptions
              templateTermsList={templateTermsList}
              selectedUsers={selectedUsers}
              handleSelectedTerm={handleSelectedTerm}
              handleMessage={handleMessage}
              message={message}
              checkedUsers={checkedUsers}
              onCheckedChange={onCheckedChange}
              handleSendTemplate={handleSendTemplate}
              loading={loading}
              handleCreateTemplate={handleCreateTemplate}
              formsByProject={formsByProject}
              handleChangeInput={handleChangeInput}
              steps={steps}
              groups={groups}
              groupQuestions={groupQuestions}
              values={values}
              showTemplateList={showTemplateList}
              handleOpenTemplateList={handleOpenTemplateList}
              handleCloseTemplateList={handleCloseTemplateList}
              setSelectedTemplate={handleSetSelectedTemplate}
              selectedTemplate={selectedTemplate}
              pinnedMessages={pinnedMessages}
            />
          </ModalBody>
          <ModalFooter className="modal-footer-communication">
            <ButtonLoader
              label="Enviar Comunicação"
              handleClick={() =>
                ModalAlert.warn({
                  title: "Confirmar envio",
                  text: "Deseja enviar esta comunicação com as mensagens selecionadas?",
                  confirmLabel: "Enviar",
                  onConfirm: () => handleSendTemplate(),
                })
              }
              isDisabled={!values?.company || !values?.subject || !values?.description || !pinnedMessages?.length}
              color="primary"
              loading={loading}
              messageProcess="Enviando Comunicação..."
            />
          </ModalFooter>
        </ModalPanel>
      )}
    </>
  )
}

const assistenciaTemplate = (text) =>
  text &&
  `Assistência:

${text}

👩‍🌾`
